module.exports = "module.exports = __webpack_public_path__ + \"static/media/tableLeader.a7c249bf.template\";"